import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/titleLine.png'
import _imports_1 from '@/assets/images/titleIcon.png'


const _hoisted_1 = { class: "relative pt-[20px] pb-[66px] title-comp" }
const _hoisted_2 = { class: "text-[22px] leading-[22px] text-[#333] text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "absolute w-[459px] left-[50%] translate-x-[-50%] top-[66px]",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "absolute w-[18px] left-[50%] translate-x-[-50%] top-[60px]",
  src: _imports_1
}, null, -1)

import { withDefaults } from "vue";
interface IProps {
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'titleComp',
  props: {
    title: { default: "员工风采" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _hoisted_3,
    _hoisted_4
  ]))
}
}

})